// import React, { useState } from 'react';
// import './ExperienceGalleryDetail.scss';
// import { Col, Row, Tag } from 'antd';
// import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
// import { IoMdArrowDropright } from 'react-icons/io';
// import img from '../../assets/images/vr-for-medical 1.png';
// import ModalGallery from '../../Components/Mersa/ModalGallery/ModalGallery';
// import { dataListViw } from '../../Data/Data';
// import { useParams } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import { getProject } from '../../Network/home';
// import { useQuery } from '@tanstack/react-query';

// const ExperienceGalleryDetail = ({ t }) => {
//   const { id } = useParams();
//   console.log(id);

//   // const data = dataListViw(t)?.find((item) => item?.id === Number(id));
//   // console.log(data);
//   const { data: dataProject, isLoading } = useQuery({
//     queryKey: ['getProject'],
//     queryFn: () => getProject(id),
//   });
//   const [open, setOpen] = useState(false);
//   // const [id,setID] = useState(0)
//   const galleryData = dataProject?.data?.images?.map((item, index) => {
//     return {
//       id: index,
//       img: item,
//     };
//   });
//   return (
//     <div className="experience-gallery-detail">
//       <Helmet>
//         <title>Projects - Merse</title>
//       </Helmet>
//       <div className="container">
//         <div className="content">
//           <div className="experience-info">
//             <h1 className="title-experience-gallery-detail">
//               {data?.titleDetails}
//             </h1>
//             <div className="experience-tags">
//               {data?.tages?.map((item) => {
//                 return <Tag className="experience-tag">{item}</Tag>;
//               })}
//             </div>
//           </div>
//           <div className="experience-description">
//             <p className="experience-description-title">{t.Overview}</p>
//             <p className="experience-description-text">{data?.Overview}</p>
//           </div>
//           <div
//             className="video"
//             style={{
//               backgroundImage: `url(${data?.img})`,
//             }}
//           >
//             <iframe
//               width="100%"
//               height="100%"
//               src={data?.video}
//               title="YouTube video player"
//               referrerpolicy="strict-origin-when-cross-origin"
//               style={{
//                 borderRadius: '20px',
//               }}
//               frameBorder="0"
//               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//               allowFullScreen
//             ></iframe>

//             {/* <IoMdArrowDropright /> */}
//           </div>
//           <div className="info-experience-gallery">
//             <p className="info-experience-gallery-description">
//               {/* {t.descriptionInfoGallery} */}
//               {data?.subTextVideo}
//             </p>
//             {/* <h1>{t.Features}</h1> */}
//             <div className="info-experience-gallery-content">
//               <div className="info-experience-gallery-content-item">
//                 <p className="info-experience-gallery-content-item-title">
//                   {/* {t.VRPlatforms} */}
//                   {data?.FeaturesTitleOne}
//                 </p>
//                 <p className="info-experience-gallery-content-item-text">
//                   {/* {t.VRPlatformsDesc}  */}
//                   {data?.FeaturesDescOne}
//                 </p>
//               </div>
//               <div className="info-experience-gallery-content-item">
//                 <p className="info-experience-gallery-content-item-title">
//                   {/* {t.MobileSolutions} */}
//                   {data?.FeaturesTitleTwo}
//                 </p>
//                 <p className="info-experience-gallery-content-item-text">
//                   {/* {t.MobileSolutionsDesc}  */}
//                   {data?.FeaturesDescTwo}
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="section-our-work-description">
//           <div className="section-our-work-description-item">
//             <div className="section-our-work-description-item-title">
//               <h2>{t.OurA}</h2>
//               <h2> {t.Approach} </h2>
//             </div>
//             <div className="section-our-work-description-item-content">
//               {data?.OurApproach?.map((item) => {
//                 return (
//                   <div className="section-our-work-description-item-text">
//                     <p className="section-our-work-description-item-text-one">
//                       {item?.title}
//                     </p>
//                     <p className="section-our-work-description-item-text-two">
//                       {item?.desc}
//                     </p>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//           <div className="section-our-work-description-item">
//             <div className="section-our-work-description-item-title">
//               <h2>{t.Key}</h2>
//               <h2> {t.Features} </h2>
//             </div>
//             <div className="section-our-work-description-item-content">
//               {data?.KeyFeatures?.map((item) => {
//                 return (
//                   <div className="section-our-work-description-item-text">
//                     <p className="section-our-work-description-item-text-one">
//                       {item?.title}
//                     </p>
//                     <p className="section-our-work-description-item-text-two">
//                       {item?.desc}
//                     </p>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//           <div className="section-our-work-description-item">
//             <div className="section-our-work-description-item-title">
//               <h2>{t.Resultsand}</h2>
//               <h2> {t.Impact} </h2>
//             </div>
//             <div className="section-our-work-description-item-content">
//               {data?.ResultsandDesc?.map((item) => {
//                 return (
//                   <div className="section-our-work-description-item-text">
//                     <p className="section-our-work-description-item-text-one">
//                       {item?.title}
//                     </p>
//                     <p className="section-our-work-description-item-text-two">
//                       {item?.desc}
//                     </p>
//                   </div>
//                 );
//               })}
//               {/* <div className="section-our-work-description-item-text">
//                         <p className='section-our-work-description-item-text-two'>

//                             {data?.ResultsandDesc}
//                         </p>
//                     </div> */}
//             </div>
//           </div>
//         </div>
//         <div className="experience-gallery-content">
//           <div className="experience-gallery-content-item">
//             <Row
//               s
//               // gutter={[50, 50]}
//               gutter={[
//                 30, 30,
//                 // { sm: 30,md: 30, lg: 30, xl: 50, xxl: 60 },
//                 // { sm: 30,md: 30, lg: 30, xl: 50, xxl: 60 },
//               ]}
//             >
//               {galleryData?.map((item, index) => (
//                 <Col
//                   sm={24}
//                   md={24}
//                   lg={12}
//                   xl={12}
//                   xxl={12}
//                   key={index}
//                   onClick={() => {
//                     // setID(index)
//                     setOpen(true);
//                   }}
//                 >
//                   <div
//                     className="experience-gallery-content-item-img"
//                     // style={{
//                     //   width: '100%',
//                     //   height: '480px',
//                     // }}
//                   >
//                     <img
//                       src={item.img}
//                       alt=""
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                       }}
//                     />
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         </div>
//         <ContactUs t={t} />
//       </div>
//       <ModalGallery open={open} setOpen={setOpen} images={data?.imgs} />
//     </div>
//   );
// };

// export default ExperienceGalleryDetail;

// import React, { useState } from 'react';
// import './ExperienceGalleryDetail.scss';
// import { Col, Row, Tag, Skeleton } from 'antd';
// import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
// import { IoMdArrowDropright } from 'react-icons/io';
// import ModalGallery from '../../Components/Mersa/ModalGallery/ModalGallery';
// import { useParams } from 'react-router-dom';
// import { Helmet } from 'react-helmet';
// import { getProject } from '../../Network/home';
// import { useQuery } from '@tanstack/react-query';

// const ExperienceGalleryDetail = ({ t }) => {
//   const { id } = useParams();

//   const { data: dataProject, isLoading } = useQuery({
//     queryKey: ['getProject', id], // Add id to queryKey to refetch when id changes
//     queryFn: () => getProject(id),
//   });

//   const [open, setOpen] = useState(false);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(0);

//   const projectData = dataProject?.data;
//   const galleryData = projectData?.images?.map((item, index) => ({
//     id: index,
//     img: item?.image,
//   }));

//   const renderContent = () => {
//     if (isLoading) {
//       return <ProjectDetailSkeleton />;
//     }

//     if (!projectData) {
//       return <div>Data not found.</div>;
//     }

//     const { name, tags, summary, images, details } = projectData;
//     const firstImage = images?.[0]?.image || ''; // Get the first image for the video section

//     return (
//       <>
//         <div className="experience-info">
//           <h1 className="title-experience-gallery-detail">{name}</h1>
//           <div className="experience-tags">
//             {tags?.map((item, index) => (
//               <Tag className="experience-tag" key={index}>
//                 {item}
//               </Tag>
//             ))}
//           </div>
//         </div>
//         <div className="experience-description">
//           <p className="experience-description-title">{t.Overview}</p>
//           <p className="experience-description-text">{summary}</p>
//         </div>
//         <div
//           className="video"
//           style={{
//             backgroundImage: `url(${firstImage})`,
//           }}
//         >
//           {/* هنا يمكنك إضافة مكون الفيديو إذا كان متاحًا */}
//           {/* حاليًا، نستخدم الصورة الأولى كخلفية */}
//         </div>
//         <div className="info-experience-gallery">
//           <p className="info-experience-gallery-description">
//             {details?.Result?.[0]?.description}
//           </p>
//           <div className="info-experience-gallery-content">
//             {details?.Tool?.map((item, index) => (
//               <div className="info-experience-gallery-content-item" key={index}>
//                 <p className="info-experience-gallery-content-item-title">
//                   {item.title}
//                 </p>
//                 <p className="info-experience-gallery-content-item-text">
//                   {item.description}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>
//         <div className="section-our-work-description">
//           {Object.keys(details || {}).map((key) => (
//             <div className="section-our-work-description-item" key={key}>
//               <div className="section-our-work-description-item-title">
//                 <h2>{t[key] || key}</h2>
//                 <h2> {t.Approach || ''} </h2>
//               </div>
//               <div className="section-our-work-description-item-content">
//                 {details[key]?.map((item, index) => (
//                   <div
//                     className="section-our-work-description-item-text"
//                     key={index}
//                   >
//                     <p className="section-our-work-description-item-text-one">
//                       {item?.title}
//                     </p>
//                     <p className="section-our-work-description-item-text-two">
//                       {item?.description}
//                     </p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </div>
//         <div className="experience-gallery-content">
//           <div className="experience-gallery-content-item">
//             <Row gutter={[30, 30]}>
//               {galleryData?.map((item, index) => (
//                 <Col sm={24} md={24} lg={12} xl={12} xxl={12} key={index}>
//                   <div
//                     className="experience-gallery-content-item-img"
//                     onClick={() => {
//                       setSelectedImageIndex(index);
//                       setOpen(true);
//                     }}
//                   >
//                     <img
//                       src={item.img}
//                       alt=""
//                       style={{
//                         width: '100%',
//                         height: '100%',
//                         objectFit: 'cover',
//                       }}
//                     />
//                   </div>
//                 </Col>
//               ))}
//             </Row>
//           </div>
//         </div>
//       </>
//     );
//   };

//   return (
//     <div className="experience-gallery-detail">
//       <Helmet>
//         <title>{projectData?.name || 'Loading...'}</title>
//       </Helmet>
//       <div className="container">
//         <div className="content">{renderContent()}</div>
//         <ContactUs t={t} />
//       </div>
//       <ModalGallery
//         open={open}
//         setOpen={setOpen}
//         // images={galleryData}
// images={projectData?.images}
//         startIndex={selectedImageIndex}
//       />
//     </div>
//   );
// };

// // Skeleton component for the loading state
// const ProjectDetailSkeleton = () => (
//   <>
//     <div className="experience-info">
//       <Skeleton.Input
//         active
//         style={{ width: '400px', height: '40px', marginBottom: '16px' }}
//       />
//       <div className="experience-tags">
//         <Skeleton.Button
//           active
//           size="small"
//           style={{ width: '100px', marginRight: '8px' }}
//         />
//         <Skeleton.Button active size="small" style={{ width: '120px' }} />
//       </div>
//     </div>
//     <div className="experience-description">
//       <Skeleton active paragraph={{ rows: 2 }} />
//     </div>
//     <div className="video">
//       <Skeleton.Image
//         active
//         style={{ width: '100%', height: '400px', borderRadius: '20px' }}
//       />
//     </div>
//     <div className="info-experience-gallery">
//       <Skeleton active paragraph={{ rows: 2 }} />
//       <div
//         className="info-experience-gallery-content"
//         style={{ marginTop: '24px' }}
//       >
//         <Skeleton active paragraph={{ rows: 1 }} />
//         <Skeleton active paragraph={{ rows: 1 }} />
//       </div>
//     </div>
//     <div className="section-our-work-description">
//       <div className="section-our-work-description-item">
//         <div className="section-our-work-description-item-title">
//           <Skeleton.Input active style={{ width: '200px', height: '28px' }} />
//         </div>
//         <div className="section-our-work-description-item-content">
//           <Skeleton active paragraph={{ rows: 1 }} />
//           <Skeleton active paragraph={{ rows: 1 }} />
//         </div>
//       </div>
//       <div className="section-our-work-description-item">
//         <div className="section-our-work-description-item-title">
//           <Skeleton.Input active style={{ width: '200px', height: '28px' }} />
//         </div>
//         <div className="section-our-work-description-item-content">
//           <Skeleton active paragraph={{ rows: 1 }} />
//           <Skeleton active paragraph={{ rows: 1 }} />
//         </div>
//       </div>
//     </div>
//     <div className="experience-gallery-content">
//       <div className="experience-gallery-content-item">
//         <Row gutter={[30, 30]}>
//           {[...Array(4)].map((_, index) => (
//             <Col sm={24} md={24} lg={12} xl={12} xxl={12} key={index}>
//               <Skeleton.Image
//                 active
//                 style={{ width: '100%', height: '480px', borderRadius: '20px' }}
//               />
//             </Col>
//           ))}
//         </Row>
//       </div>
//     </div>
//   </>
// );

// export default ExperienceGalleryDetail;

import React, { useState } from 'react';
import './ExperienceGalleryDetail.scss';
import { Col, Row, Tag, Skeleton } from 'antd';
import ContactUs from '../../Components/Mersa/ContactUs/ContactUs';
import { IoMdArrowDropright } from 'react-icons/io';
import img from '../../assets/images/vr-for-medical 1.png';
import ModalGallery from '../../Components/Mersa/ModalGallery/ModalGallery';
import { dataListViw } from '../../Data/Data';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getProject } from '../../Network/home';
import { useQuery } from '@tanstack/react-query';

const ExperienceGalleryDetail = ({ t }) => {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const { data: dataProject, isLoading } = useQuery({
    queryKey: ['getProject', id],
    queryFn: () => getProject(id),
  });

  const projectData = dataProject?.data;
  const galleryData =
    projectData?.images?.map((item, index) => ({
      id: index,
      img: item.image,
    })) || [];

  const renderContent = () => {
    if (isLoading) {
      return (
        <>
          <div className="experience-info">
            <Skeleton active title={{ width: 300 }} paragraph={{ rows: 0 }} />
            <div className="experience-tags">
              <Skeleton.Button active style={{ width: 100, marginRight: 8 }} />
              <Skeleton.Button active style={{ width: 120 }} />
            </div>
          </div>
          <div className="experience-description">
            <p className="experience-description-title">
              <Skeleton.Input active style={{ width: 150 }} />
            </p>
            <p className="experience-description-text">
              <Skeleton active paragraph={{ rows: 2 }} />
            </p>
          </div>
          <div className="video">
            <Skeleton.Image
              active
              style={{ width: '100%', height: '400px', borderRadius: '20px' }}
            />
          </div>
          <div className="info-experience-gallery">
            <p className="info-experience-gallery-description">
              <Skeleton active paragraph={{ rows: 2 }} />
            </p>
            <div className="info-experience-gallery-content">
              <div className="info-experience-gallery-content-item">
                <p className="info-experience-gallery-content-item-title">
                  <Skeleton active paragraph={{ rows: 1 }} />
                </p>
                <p className="info-experience-gallery-content-item-text">
                  <Skeleton active paragraph={{ rows: 1 }} />
                </p>
              </div>
              <div className="info-experience-gallery-content-item">
                <p className="info-experience-gallery-content-item-title">
                  <Skeleton active paragraph={{ rows: 1 }} />
                </p>
                <p className="info-experience-gallery-content-item-text">
                  <Skeleton active paragraph={{ rows: 1 }} />
                </p>
              </div>
            </div>
          </div>
          <div className="section-our-work-description">
            <div className="section-our-work-description-item">
              <div className="section-our-work-description-item-title">
                <h2>
                  <Skeleton.Input active style={{ width: 150 }} />
                </h2>
              </div>
              <div className="section-our-work-description-item-content">
                <div className="section-our-work-description-item-text">
                  <p className="section-our-work-description-item-text-one">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </p>
                  <p className="section-our-work-description-item-text-two">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </p>
                </div>
              </div>
            </div>
            <div className="section-our-work-description-item">
              <div className="section-our-work-description-item-title">
                <h2>
                  <Skeleton.Input active style={{ width: 150 }} />
                </h2>
              </div>
              <div className="section-our-work-description-item-content">
                <div className="section-our-work-description-item-text">
                  <p className="section-our-work-description-item-text-one">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </p>
                  <p className="section-our-work-description-item-text-two">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </p>
                </div>
              </div>
            </div>
            <div className="section-our-work-description-item">
              <div className="section-our-work-description-item-title">
                <h2>
                  <Skeleton.Input active style={{ width: 150 }} />
                </h2>
              </div>
              <div className="section-our-work-description-item-content">
                <div className="section-our-work-description-item-text">
                  <p className="section-our-work-description-item-text-one">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </p>
                  <p className="section-our-work-description-item-text-two">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="experience-gallery-content">
            <div className="experience-gallery-content-item">
              <Row gutter={[30, 30]}>
                {[...Array(4)].map((_, index) => (
                  <Col sm={24} md={24} lg={12} xl={12} xxl={12} key={index}>
                    <Skeleton.Image
                      active
                      style={{
                        width: '100%',
                        height: '480px',
                        borderRadius: '20px',
                      }}
                    />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </>
      );
    }

    if (!projectData) {
      return <div>No project data found.</div>;
    }

    const { name, tags, summary, images, details, youtube } = projectData;
const getEmbedUrl = (url) => {
  if (!url) return "";
  if (url.includes("watch?v=")) {
    return url.replace("watch?v=", "embed/");
  }
  return url; // already in correct embed format
};

const embedUrl = getEmbedUrl(youtube);
    return (
      <>
        <div className="experience-info">
          <h1 className="title-experience-gallery-detail">{name}</h1>
          <div className="experience-tags">
            {tags?.map((item, index) => (
              <Tag className="experience-tag" key={index}>
                {item}
              </Tag>
            ))}
          </div>
        </div>
        <div className="experience-description">
          <p className="experience-description-title">{t.Overview}</p>
          <p className="experience-description-text">{summary}</p>
        </div>
        {/* <div
          className="video"
          // style={{
          //   backgroundImage: `url(${images?.[0]?.image})`,
          // }}
        >
          <iframe
            src={youtube}
            title="YouTube video player"
            frameborder="0"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div> */}
         <div className="video">
    <iframe
      src={embedUrl}
      title="YouTube video player"
      frameBorder="0"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>

        <div className="info-experience-gallery">
          <p className="info-experience-gallery-description">
            {details?.Result?.[0]?.description}
          </p>
          <div className="info-experience-gallery-content">
            {details?.Tool?.map((item, index) => (
              <div className="info-experience-gallery-content-item" key={index}>
                <p className="info-experience-gallery-content-item-title">
                  {item.title}
                </p>
                <p className="info-experience-gallery-content-item-text">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="section-our-work-description">
          <div className="section-our-work-description-item">
            <div className="section-our-work-description-item-title">
              <h2>{t.OurA}</h2>
              <h2> {t.Approach} </h2>
            </div>
            <div className="section-our-work-description-item-content">
              {details?.Approach?.map((item, index) => (
                <div
                  className="section-our-work-description-item-text"
                  key={index}
                >
                  <p className="section-our-work-description-item-text-one">
                    {item?.title}
                  </p>
                  <p className="section-our-work-description-item-text-two">
                    {item?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="section-our-work-description-item">
            <div className="section-our-work-description-item-title">
              <h2>{t.Key}</h2>
              <h2> {t.Features} </h2>
            </div>
            <div className="section-our-work-description-item-content">
              {details?.Feature?.map((item, index) => (
                <div
                  className="section-our-work-description-item-text"
                  key={index}
                >
                  <p className="section-our-work-description-item-text-one">
                    {item?.title}
                  </p>
                  <p className="section-our-work-description-item-text-two">
                    {item?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="section-our-work-description-item">
            <div className="section-our-work-description-item-title">
              <h2>{t.Resultsand}</h2>
              <h2> {t.Impact} </h2>
            </div>
            <div className="section-our-work-description-item-content">
              {details?.Result?.map((item, index) => (
                <div
                  className="section-our-work-description-item-text"
                  key={index}
                >
                  <p className="section-our-work-description-item-text-one">
                    {item?.title}
                  </p>
                  <p className="section-our-work-description-item-text-two">
                    {item?.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="experience-gallery-content">
          <div className="experience-gallery-content-item">
            <Row gutter={[30, 30]}>
              {galleryData?.map((item, index) => (
                <Col
                  sm={24}
                  md={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  key={index}
                  onClick={() => {
                    setSelectedImageIndex(index);
                    setOpen(true);
                  }}
                >
                  <div className="experience-gallery-content-item-img">
                    <img
                      src={item.img}
                      alt=""
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="experience-gallery-detail">
      <Helmet>
        <title>{projectData?.name || 'Loading...'}</title>
      </Helmet>
      <div className="container">
        <div className="content">{renderContent()}</div>
        <ContactUs t={t} />
      </div>
      <ModalGallery
        open={open}
        setOpen={setOpen}
        // images={galleryData}
        images={projectData?.images}
        startIndex={selectedImageIndex}
      />
    </div>
  );
};

export default ExperienceGalleryDetail;
